import { generator } from '@philips-internal/oswald-ui-core/lib/client/event-listener';

const OnSubmitTermUse = generator('onSubmitTermUse');
const OnClickAviso = generator('onClickAviso');
const OnClickTermo = generator('onClickTermo');
const OnClickTermoConsent = generator('onClickTermoConsent');

export {
  OnSubmitTermUse,
  OnClickAviso,
  OnClickTermo,
  OnClickTermoConsent,
}